<template>

  <div style="margin-top: 20px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width: 750px; margin: 0px auto;">
          <div  slot="header" class="clearfix">
            系统消息
          </div>
          <el-timeline style="overflow:auto">
            <template v-for="item in notices">
              <el-timeline-item :timestamp="item.DateCreatedStr" placement="top">
                <el-card>
                  <h4>{{item.Name}}</h4>
                  <p>{{item.Content}}</p>
                </el-card>
              </el-timeline-item>
            </template>
          </el-timeline>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import localforage from 'localforage'
  export default {
    name: 'Notices',
    data(){
      return{
        notices:'',
        pageIndex:1,
        pageSize:10
      }
    },
    methods:{
      getNotices(){
        let para={
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        this.pageIndex+=1
        this.$http.get('/api//user/notices',{params:para}).then(res=>{
         if(res!=null && this.notices.length==0){
           this.notices=res.data
           localforage.setItem('notices',res.data)
         }
        })
      },
      load(){
        this.getNotices()
      },
      loadMore(){
        this.getNotices()
      },
      onRead(){
        this.$store.commit('SET_NOTICEVALUE',0)
        localforage.setItem('noticeValue',0)
      }
    },
    mounted () {
      this.onRead()
      this.load()
    }
  }
</script>

<style scoped>

</style>
